// extracted by mini-css-extract-plugin
module.exports = {"brandguideOptions":"brandguideOptions__So8Z4"};